import React from 'react'
import { Intercom, LiveChatLoaderProvider } from 'react-live-chat-loader'

export default function IntercomChatProvider() {
	return (
		<LiveChatLoaderProvider providerKey="ou59l8iq" provider="intercom">
			<Intercom />
		</LiveChatLoaderProvider>
	)
}
